import React, { useCallback, useContext, useEffect, useState } from 'react'
import {
  Table,
  TableHead,
  TableRow,
  TableBody,
  TableCell,
  Tooltip,
  Button,
  Modal,
  Box,
  Typography,
  Backdrop,
  CircularProgress,
  Autocomplete,
  Divider,
  Switch,
  FormControl,
  FormLabel,
  FormControlLabel,
  FormGroup,
  Skeleton,
  Checkbox,
  Fab,
  Step,
  StepLabel,
  StepContent,
  Stepper,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Rating,
  TextField,
  Snackbar,
  Alert,
  List,
  ListItemAvatar,
  Avatar,
  AvatarGroup,
  Chip,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  LinearProgress,
} from "@mui/material";
import { MainContext } from '../../../context/main/main-context';
import { debounce } from 'lodash';
import DataHandler from '../../../handlers/DataHandler';
import MaterialCustomTablePagination from '../../../components/common/MaterialCustomTablePagination';
import AddSection from './modals/AddSection';
import AddPart from './modals/AddPart';


function PartTab() {

  const { parts, fetchAllParts, templateMetaData } = useContext(MainContext);


  const [isOpen, setIsOpen] = useState(false)
  const [partLoading, setPartLoading] = useState(false)
  const [currentPart, setCurrentPart] = useState(null)

  const [currentPage, setCurrentPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)

  const [state, setState] = useState({
    limit: 10,
    offset: 0,
    sort_column: 'created_at',
    sort_direction: 'DESC',
  });

  const handlePageChange = (event, newPage) => {

    const newOffset = newPage * rowsPerPage;

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)

  };

  const handleRowsPerPageChange = (event) => {

    const newLimit = parseInt(event.target.value, 10);
    const newPage = Math.floor(state.offset / newLimit);

    setState((prevState) => ({
      ...prevState,
      limit: newLimit,
      offset: newLimit * newPage
    }));
    setCurrentPage(newPage)

  };

  const handlePageOffsetChange = (newOffset, newPage) => {

    setState((prevState) => ({
      ...prevState,
      limit: rowsPerPage,
      offset: newOffset
    }));
    setCurrentPage(newPage)
  };

  const handlefetchAllParts = useCallback(
    debounce(async () => {
      const {
        limit,
        offset,
        sort_column,
        sort_direction
      } = state;

      const user_id = DataHandler.getFromSession('manage_user_id');


      setPartLoading(true)

      try {

        await fetchAllParts(limit, offset, sort_column, sort_direction, user_id);

      } catch (error) {
        console.error('Error fetching parts:', error);
      } finally {
        setPartLoading(false)
      }
    }, 300),
    [state]
  );

  const handleaddPart = () => {
    setIsOpen(true)
  }

  const updatePart = (partData) => {

    if (partData) {
      setCurrentPart(partData)
      setIsOpen(true)
    }

  }

  const closeUpdateModal = (value) => {
    setIsOpen(value)
    // handlefetchAllParts()
  }

  useEffect(() => {
    handlefetchAllParts()
  }, [state])

  useEffect(() => {

    if (parts && parts.success) {
      setPartLoading(false)
    }
  }, [parts])

  const getPartNotationTypeById = (id) => {
    const notation = templateMetaData?.notations?.find(notation => notation.notation_id === id);
    return notation ? notation.notation_type : "N/A";
  };

  return (
    <Box>
      <Button sx={{ mt: 3, backgroundColor: '#63239A', borderRadius: '8px' }} onClick={handleaddPart} variant='contained'>
        Add New Part
      </Button>
      {/* Card-grid layout replacing table rows */}
      <div className="part-cards-grid">
        {parts?.data?.parts && parts.data.parts.length > 0 && !partLoading ? (
          parts.data.parts.map((part, index) => (
            <div key={index} className="part-card">
              <div className="part-card-left">
                <div className="part-notation">{getPartNotationTypeById(part.notation_id) || ''}</div>
                <div style={{ minWidth: 0 }}>
                  <div className="part-title" title={part.name}>{part.name || ''}</div>
                  <Tooltip title={part.description || 'N/A'} placement="bottom-start" arrow>
                    <div className="part-description">{part.description || 'N/A'}</div>
                  </Tooltip>
                </div>
              </div>

              {/* Middle row: Assigned to (keeps three-line layout) */}
              <div className="part-assigned">
                <span className="part-assigned-label">Assigned to</span>
                <span className="part-assigned-name">
                  {part.assigned_to || part.assigned_user_name || part.teacher_name || part.assignee || part.assigned || 'N/A'}
                </span>
              </div>

              <div className="part-card-right">
                <div className={`part-status ${part?.status_id === 1 ? 'active' : 'inactive'}`}>
                  {part?.status_id === 1 ? 'Active' : 'InActive'}
                </div>

                <div className="part-actions">
                  <button
                    className="part-action-btn edit"
                    title="Edit details"
                    onClick={() => updatePart(part)}
                  >
                    <i className="flaticon-edit" />
                  </button>
                </div>
              </div>
            </div>
          ))
        ) : (
          partLoading ? (
            <>
              {[1, 2, 3, 4].map(i => (
                <div key={i} className="part-card-skeleton">
                  <Skeleton variant="text" width="40%" height={24} />
                  <Skeleton variant="rectangular" width="60%" height={20} sx={{ mt: 1 }} />
                </div>
              ))}
            </>
          ) : (
            <div>No Templates</div>
          )
        )}
      </div>

      <div className="d-flex justify-content-end">
        <MaterialCustomTablePagination
          totalCount={parts?.data?.total_count || 0}
          currentPage={currentPage}
          limit={state.limit}
          handlePageChange={handlePageChange}
          handleRowsPerPageChange={handleRowsPerPageChange}
          handlePageOffsetChange={handlePageOffsetChange}
          offset={state.offset}
          rowsPerPageOptions={[5, 10, 15, 20, 25, 50, 75, 100, 150, 200, 250, 300]}
        />
      </div>

      {isOpen &&
        <AddPart isOpen={isOpen} setIsOpen={closeUpdateModal} currentPart={currentPart} setCurrentPart={setCurrentPart} handlefetchAllParts={handlefetchAllParts} />
      }
    </Box>
  )
}

export default PartTab